import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Tabs, Tab, Typography, withTheme } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  appBar: {
    // outline: '1px solid red'
  },
  // TODO - Need to use these units from theme once units are available
  tabsRoot: {
    minHeight: 40
  },
  tabRoot: {
    minWidth: 16,
    height: 40,
    borderBottom: `1px solid ${theme.palette.secondary['medium']}`
  },
  tabSelected: {
    color: theme.palette.primary.main
  },
  tabsIndicator: {
    height: 3,
    backgroundColor: theme.palette.primary.main
  }
})


export class TabContainer extends React.Component<{}> {
  static defaultProps = {}

  render() {
    const {props} = this;
    return (
      <Typography component='div' style={{padding: 8 * 3}}>
        {props.children}
      </Typography>
    )
  }
}

interface SimpleTabsProps extends StyledProps {
  /** Data object to populate tabs and tab content areas */
  data: any
  /** Number indicating the selected/active tab, starting at 0 */
  value: number
  /** Function to be called on Button Click */
  onChange: (e, v) => void

}

export class SimpleTabsComponent extends React.Component<SimpleTabsProps> {
  static defaultProps = {
    value: 0
    }

  render() {
    const {classes, data, value, onChange} = this.props
    return (
      <div>
        <Tabs classes={{root: classes.tabsRoot, indicator: classes.tabsIndicator}} value={value} onChange={onChange}>
          {Object.keys(data).map(key => <Tab key={key} classes={{root: classes.tabRoot, selected: classes.tabSelected}} label={data[key].label}/>)}
        </Tabs>
        {Object.keys(data).map(key => {
          const Content = () => data[key].content
          return value === parseInt(key) ? <TabContainer key={key}><Content/></TabContainer> : null
        })}
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class SimpleTabs extends SimpleTabsComponent{}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Tabs.tsx